const sizes = {
  app: '980px',
};

export default sizes;
